import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Link = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="link icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4142 14.4142L20 6.82843V10C20 11.1046 20.8954 12 22 12C23.1046 12 24 11.1046 24 10V2L24 1.99077C23.9976 1.482 23.8024 0.973963 23.4142 0.585786C23.2225 0.394033 23.0015 0.249357 22.7656 0.151757C22.5298 0.0539709 22.2708 0 21.9997 0L14 0C12.8954 0 12 0.89543 12 2C12 3.10457 12.8954 4 14 4H17.1716L9.58579 11.5858C8.80474 12.3668 8.80474 13.6332 9.58579 14.4142C10.3668 15.1953 11.6332 15.1953 12.4142 14.4142ZM7 1.48199C3.96243 1.48199 1.5 3.94443 1.5 6.98199V16.982C1.5 20.0196 3.96243 22.482 7 22.482H17C20.0376 22.482 22.5 20.0196 22.5 16.982V15.982C22.5 15.1536 21.8284 14.482 21 14.482C20.1716 14.482 19.5 15.1536 19.5 15.982V16.982C19.5 18.3627 18.3807 19.482 17 19.482H7C5.61929 19.482 4.5 18.3627 4.5 16.982V6.98199C4.5 5.60128 5.61929 4.48199 7 4.48199H8C8.82843 4.48199 9.5 3.81042 9.5 2.98199C9.5 2.15357 8.82843 1.48199 8 1.48199H7Z"
    />
  </svg>
)
